import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { env } from "src/env";
import User from "src/models/Base/Auth/User";
import store from "src/store";
import AuthSlice from "src/store/Slices/Base/AuthSlice";
// import notify from 'src/utils/SnackbarUtils';

enum StatusCode {
  Unauthorized = 401,
  Forbidden = 403,
  TooManyRequests = 429,
  InternalServerError = 500,
}

const headers: Readonly<Record<string, string | boolean>> = {
  Accept: "application/json",
  "Content-Type": "application/json; charset=utf-8",
  "Access-Control-Allow-Credentials": true,
  "X-Requested-With": "XMLHttpRequest",
};

// We can use the following function to inject the JWT token through an interceptor
// We get the `accessToken` from the localStorage that we set when we authenticate
const injectToken = (config: AxiosRequestConfig): AxiosRequestConfig => {
  try {
    const userLogin: User = JSON.parse(sessionStorage.getItem('userLogin'))
    if (userLogin != null) {
      config.headers.Authorization = "Bearer " + userLogin.accessToken;
    }
    return config;
  } catch (error) {
    throw new Error(error);
  }
};

// Handle global app errors
// We can handle generic app errors depending on the status code
const handleError = (error) => {
  const { status } = error;

  switch (status) {
    case StatusCode.InternalServerError: {
      // Handle InternalServerError
      break;
    }
    case StatusCode.Forbidden: {
      // Handle Forbidden
      break;
    }
    case StatusCode.Unauthorized: {
      // Handle Unauthorized
      store.dispatch(AuthSlice.actions.logOut())
      break;
    }
    case StatusCode.TooManyRequests: {
      // Handle TooManyRequests
      break;
    }
  }

  return Promise.reject(error);
}

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
}

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
}

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  if (!error.response)
    return Promise.reject(error);

  const { response } = error;
  return handleError(response);
}

class Http {
  private instance: AxiosInstance | null = null;

  private get http(): AxiosInstance {
    //const PORT = parseInt(process.env.REACT_APP_REST_API_PORT || "3000", 10)
    //const API_BASE_URL = process.env.REACT_APP_REST_API_BASEURL || `http://localhost:${PORT}/api/v1`;
    //return this.instance != null ? this.instance : this.initHttp("/api/api/v1"); // api/api/v1 Frontend ve backend aynı porttaysa kullanılır
    return this.instance != null ? this.instance : this.initHttp(env.REACT_APP_WEP_API_URL);
  }

  initHttp(baseURL: string) {
    const http = axios.create({
      baseURL,
      headers,
      withCredentials: false, //true
    });

    http.interceptors.request.use((config) => {
      injectToken(config);
      return config;
    }, onRequestError);
    http.interceptors.response.use(onResponse, onResponseError);

    this.instance = http;
    return http;
  }

  request<T = any, R = AxiosResponse<T>>(config: AxiosRequestConfig): Promise<R> {
    return this.http.request(config);
  }

  get<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
    return this.http.get<T, R>(url, config);
  }

  post<T = any, R = AxiosResponse<T>>(
    url: string,
    data?: T,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.http.post<T, R>(url, data, config);
  }

  put<T = any, R = AxiosResponse<T>>(
    url: string,
    data?: T,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.http.put<T, R>(url, data, config);
  }

  // delete<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
  //   return this.http.delete<T, R>(url, config);
  // }

  delete<T = string, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
    return this.http.delete<T, R>(url, config);
  }
}

export const http = new Http();

